import { useState } from "react";
import styled, { css, keyframes } from "styled-components";
import ym from "react-yandex-metrika";
import { message } from "./Message";
import { config } from "../core/config";
import promoBg from '../images/promo/promo-lift-vk30.jpg'
import googlePlay from '../images/apps/googleplay.svg';
import appStore from '../images/apps/appstore.svg';
import ruStore from '../images/apps/rustore.svg';
import { LogoIcon } from "./Icons";

const PromoScreen = ({ promocode, onClose }) => {
    const [showAppStores, setShowAppStores] = useState(false);
    const [copied, setCopied] = useState(false);
    const [showMessage, setShowMessage] = useState(false);

    const handleClose = () => {
        ym('reachGoal','click_close_without_promocode');
        onClose();
    };

    const handleCopy = () => {
        ym('reachGoal','click_confirm_use_promocode');
        setCopied(true);
        if (promocode) {
            navigator.clipboard.writeText(promocode)
                .then(() => {
                    message({type: 'default', title: 'Промокод скопирован', body: `Промокод ${promocode} успешно скопирован!`});
                    setCopied(true);
                })
                .catch(err => {
                    console.error('Не удалось скопировать промокод:', err);
                });
        }
    };

    const handleOrderOnSite = () => {
        ym('reachGoal','click_confirm_use_promocode');
        if (promocode) {
            navigator.clipboard.writeText(promocode)
                .then(() => {
                    sessionStorage.setItem('activePromoCode', promocode);
                    setShowMessage(true);
                    // message({type: 'default', title: 'Промокод сохранен', body: 'Промокод будет применён автоматически в вашей корзине'});
                    // onClose();
                })
                .catch(err => {
                    console.error('Не удалось сохранить промокод:', err);
                });
        }
    };

    const handleOrderInApp = () => {
        setShowAppStores(!showAppStores);
    };

    const handleClickApp = () => {
        ym('reachGoal','click_apps_without_promocode');
    };

    return (
        <FullScreenContainer>
            <BackgroundImage src={promoBg} alt="Фоновое изображение акции" />
            <DarkOverlay />
            {showMessage ? 
                <ContentWrapper>
                    <div style={{margin: 'auto 0'}}>
                        <span style={{color: '#14b10f'}}>Промокод сохранен</span>
                        <PromoTitle>Промокод будет применён автоматически в вашей корзине</PromoTitle>
                        <MainButtons>
                            <OrderButton onClick={onClose} $primary>
                                Продолжить
                            </OrderButton>
                        </MainButtons>
                    </div>
                </ContentWrapper>
            :
                <ContentWrapper>
                    <LogoWrapper>
                        <LogoIcon/>
                    </LogoWrapper>

                    <PromoTitle>Обед со скидкой {promocode === 'PENZA50' ? '50%' : '30%'} по промокоду</PromoTitle>
                    <PromoCode>{promocode}</PromoCode>
                    
                    <ActionButton disabled={copied} onClick={handleCopy}>
                        {copied ?
                            <>
                                <CheckIcon>✓</CheckIcon>
                                <span>Скопировано</span>
                            </>
                        :
                            <>
                                <ClipboardIcon>📋</ClipboardIcon>
                                <span>Скопировать промокод</span>
                            </>
                        }
                    </ActionButton>

                    <MainButtons>
                        <OrderButton onClick={handleOrderOnSite} $primary>
                            Заказать на сайте
                        </OrderButton>
                        <OrderButton onClick={handleOrderInApp}>
                            Заказать в приложении
                        </OrderButton>
                    </MainButtons>

                    <AppStores open={showAppStores}>
                        <AppLink href={config.appLinks.appstore} onClick={handleClickApp}>
                            <img width="160" height="60" src={appStore} alt="appStore"/>
                        </AppLink>
                        <AppLink href={config.appLinks.playmarket} onClick={handleClickApp}>
                            <img width="160" height="60" src={googlePlay} alt="googlePlay"/> 
                        </AppLink>
                        <AppLink href={config.appLinks.rustore} onClick={handleClickApp}>
                            <img width="160" height="60" src={ruStore} alt="ruStore"/>
                        </AppLink>
                    </AppStores>

                    <BenefitsList>
                        <BenefitItem>
                            <CheckIcon>✓</CheckIcon>
                            <span>Доставка бесплатно</span>
                        </BenefitItem>
                        <BenefitItem>
                            <CheckIcon>✓</CheckIcon>
                            <span>Минимальный заказ - 100р.</span>
                        </BenefitItem>
                    </BenefitsList>
                </ContentWrapper>
            }
            <ContinueButton onClick={handleClose}>×</ContinueButton>
        </FullScreenContainer>
    );
};

export default PromoScreen;

// Анимации
const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const slideUp = keyframes`
  from { 
    transform: translateY(20px); 
    opacity: 0;
  }
  to { 
    transform: translateY(0); 
    opacity: 1;
  }
`;

const slideDown = keyframes`
  from { 
    transform: translateY(0);
    opacity: 1;
  }
  to { 
    transform: translateY(20px);
    opacity: 0;
  }
`;

// Основные стили
const FullScreenContainer = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100vw;
    height: 100vh;
    background: #000000;
    animation: ${fadeIn} 0.3s;
    overflow: auto;
`;

const BackgroundImage = styled.img`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    z-index: 1;
`;

const DarkOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    z-index: 2;
`;

const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 600px;
    height: 100%;
    padding: 60px 16px;
    text-align: center;
    color: white;
    z-index: 3;
    animation: ${slideUp} 0.7s ease-out;
`;

const LogoWrapper = styled.div`
    margin-bottom: 32px;
    height: 45px;
    svg {
        width: auto;
        height: 45px;
    }
`;

const PromoTitle = styled.h1`
    max-width: 600px;
    font-size: clamp(24px, 5vw, 36px);
    font-weight: 700;
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
`;

const PromoCode = styled.div`
    font-size: clamp(36px, 8vw, 64px);
    font-weight: 900;
    margin: 16px auto;
    color: #FFD700;
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);
    letter-spacing: 3px;
    background: rgba(0, 0, 0, 0.3);
    display: inline-block;
    padding: 10px 30px;
    width: fit-content;
    border-radius: 10px;
    border: 2px dashed rgba(255, 215, 0, 0.5);
`;

const ActionButton = styled.button`
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    background: transparent;
    color: white;
    border: 2px solid rgba(255, 255, 255, 0.3);
    padding: 0 32px;
    min-height: 45px;
    font-size: clamp(14px, 3vw, 16px);
    border-radius: 50px;
    cursor: pointer;
    transition: all 0.3s;
    
    &:hover {
        background: rgba(255, 255, 255, 0.1);
        border-color: white;
    }
`;

const ClipboardIcon = styled.span`
    font-size: 20px;
`;

const ContinueButton = styled(ActionButton)`
    position: fixed;
    top: 24px;
    right: 24px;
    width: 46px;
    padding: 0 12px;
    z-index: 10;
    font-size: 36px;
`;

const MainButtons = styled.div`
    margin-top: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px;
    width: 100%;
`;

const OrderButton = styled.button`
    background: ${props => props.$primary ? '#FFD700' : 'transparent'};
    color: ${props => props.$primary ? '#000' : '#FFF'};
    border: 2px solid ${props => props.$primary ? '#FFD700' : 'rgba(255, 255, 255, 0.3)'};
    padding: 15px 30px;
    font-size: 16px;
    font-weight: 600;
    border-radius: 50px;
    cursor: pointer;
    transition: all 0.3s;
    
    &:hover {
        background: ${props => props.$primary ? '#FFC000' : 'rgba(255, 255, 255, 0.1)'};
        border-color: ${props => props.$primary ? '#FFC000' : '#FFF'};
    }
`;

const AppStores = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px;
    width: 100%;
    margin: 16px auto 0;
    animation: ${({open}) => open 
        ? css`${slideUp} 0.3s forwards` 
        : css`${slideDown} 0.3s forwards`};
    visibility: ${({open}) => open ? 'visible' : 'hidden'};
    height: ${({open}) => open ? 'auto' : '0'};
`;

const AppLink = styled.a`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 160px;
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 16px;
    overflow: hidden;
    text-align: center;
    text-decoration: none;
    transition: all 0.3s;
    &:hover {
        background: rgba(255, 255, 255, 0.2);
        border-color: white;
    }
`;

const BenefitsList = styled.ul`
    max-width: 600px;
    list-style: none;
    padding: 0;
    margin-top: 32px;
    background: rgba(0, 0, 0, 0.4);
    padding: 20px;
    border-radius: 15px;
    backdrop-filter: blur(5px);
`;

const BenefitItem = styled.li`
    font-size: clamp(18px, 4vw, 22px);
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 15px;
`;

const CheckIcon = styled.span`
    color: #4CAF50;
    font-size: 24px;
    font-weight: bold;
`;
